import AddQuickSmsCard from './AddQuickSms/AddQuickSmsCard';

const QuickSms = (props: any) => {
  const { refetch } = props;
  return (
    <>
      <AddQuickSmsCard refetch={refetch} />
    </>
  );
};

export default QuickSms;
